// Global Instructions Rule Applied!
//
// Single source of truth for account-role <Select> options.
//
// Auto-assigned roles (cfg.account_role_rules signals with add_only=false,
// surfaced as `is_auto_assigned` by get_global_configs_v3) are managed
// end-to-end by the reconcile engine, so they are rendered read-only (disabled)
// in EVERY role picker. Add-only roles and purely manual roles stay
// selectable. Since 20270409120100 every rule is add-only - Portfolio Company /
// Exited included, so a person can set them where the ledger cannot tell - and
// no role is disabled; the rule stays here for a cfg that flips one back.
//
// Every role editor — company/deal/contact forms and the grid inline editors —
// builds its options through this helper so the read-only rule lives in exactly
// one place and cannot drift out of sync again.

export interface AccountRoleChoiceOption {
  value: string
  label: string
  disabled: boolean
}

interface AccountRoleChoiceLike {
  id: string
  role?: string | null
  is_auto_assigned?: boolean | null
}

export function buildAccountRoleOptions(
  accountRoleChoices: AccountRoleChoiceLike[] | undefined | null
): AccountRoleChoiceOption[] {
  return (accountRoleChoices ?? []).map((choice) => ({
    value: choice.id,
    label: choice.role ?? '',
    disabled: !!choice.is_auto_assigned
  }))
}
